import { render, staticRenderFns } from "./downloadPlugin.vue?vue&type=template&id=0f17e0ca&scoped=true"
import script from "./downloadPlugin.vue?vue&type=script&lang=js"
export * from "./downloadPlugin.vue?vue&type=script&lang=js"
import style0 from "./downloadPlugin.vue?vue&type=style&index=0&id=0f17e0ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17e0ca",
  null
  
)

export default component.exports